import { render, staticRenderFns } from "./page-header-content.vue?vue&type=template&id=1d9290e2"
import script from "./page-header-content.vue?vue&type=script&lang=js"
export * from "./page-header-content.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports